module.exports = __webpack_public_path__ + "img/20220423_162523.54a988e8.jpg";